module.exports = __webpack_public_path__ + "static/media/GhostScepter.6c5a66d5.png";